<div [ngStyle]="{ 'background-color': getColor }" class="name-icon-container">
  <span *ngIf="names.length && !icon">{{ getText }}</span>
  <mat-icon class="notranslate material-symbols-rounded" *ngIf="!names.length && !svgIcon && icon">{{icon}}</mat-icon>
  <mat-icon class="notranslate material-symbols-rounded" *ngIf="!names.length && !icon && svgIcon" [svgIcon]="svgIcon"></mat-icon>
</div>
